import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, AfterViewInit, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common'
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { EducationService } from '../../services/education.service';
import { InventoryService } from '../../services/inventory.service';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { MatSortModule, MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, ValidationErrors, FormControl, UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { DropzoneComponent, DropzoneDirective, DropzoneConfigInterface } from 'ngx-dropzone-wrapper';

import { AngularEditorConfig } from '@kolkov/angular-editor';
import { PrintService } from '../../services/print.service'
import { match } from 'assert';

@Component({
	selector: 'app-education-events',
	templateUrl: './education-events.component.html',
	styleUrls: ['./education-events.component.scss']
})
export class EducationEventsComponent implements OnInit{
	@ViewChild('print_table_pdf', { static: false }) printtablepdf: ElementRef;
	@ViewChild('print_table_main', { static: false }) printtablepdfmain: ElementRef;
	@ViewChild('print_table_xlsx', { static: false }) printtablexlsx: ElementRef;
	sending = false;
	color = '';
	eventlist: any = [];
	sortedlist: any = [];
	allevents: any = [];
	@ViewChild('attendees') attendeeRef: ElementRef;
	@ViewChild('setupModal') setupRef: ElementRef;
	dataSource: MatTableDataSource < any > ;
	@ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

	
	
	dataObs: Observable < any > ;
	items_per_page = [5, 10, 20, 100, 500, 1000];
	pagesizedefault = 20;
	selected_event: any = [];
	loading: any = false;
	eventForm: UntypedFormGroup;
	categoryCtrl: any = new UntypedFormControl('');
	brandCtrl: any = new UntypedFormControl('');
	descCtrl: any = new UntypedFormControl('');
	prodCtrl: any = new UntypedFormControl('');
	desc2Ctrl: any = new UntypedFormControl('');
	files: File[] = [];
	uploadresults: any = [];
	productlist: any = [];
	categories: any = [];
	brands: any = [];
	productlines: any = [];
	eventlocations: any = [];
	eventregions: any = [];
	picklist: any = [];
	productsSearching = false;
	sortColumns: any = [{ column: 'name',sort:'asc'}];
	sortDirections = [];
	
	searchTerm = '';
	statusFilter = 'enabled'; // Possible values: 'both', 'enabled', 'disabled'
	searchCtrl: UntypedFormControl = new UntypedFormControl('');
	statusCtrl: UntypedFormControl = new UntypedFormControl('enabled');
	searching = false;
	saving = false;
	//Well this is stupid.
	hours: any = [{ disp: '12a', value: '00' }, { disp: '1a', value: '01' }, { disp: '2a', value: '02' }, { disp: '3a', value: '03' }, { disp: '4a', value: '04' }, { disp: '5a', value: '05' },
		{ disp: '6a', value: '06' }, { disp: '7a', value: '07' }, { disp: '8a', value: '08' }, { disp: '9a', value: '09' }, { disp: '10a', value: '10' }, { disp: '11a', value: '11' },
		{ disp: '12p', value: '12' }, { disp: '1p', value: '13' }, { disp: '2p', value: '14' }, { disp: '3p', value: '15' }, { disp: '4p', value: '16' }, { disp: '5p', value: '17' },
		{ disp: '6p', value: '18' }, { disp: '7p', value: '19' }, { disp: '8p', value: '20' }, { disp: '9p', value: '21' }, { disp: '10p', value: '22' }, { disp: '11p', value: '23' }
	];

	// hours: any[] = Array.from({ length: 24 }, (_, i) => ({
	//   value: i.toString().padStart(2, '0'), // '00' to '23'
	//   display: new Date(0, 0, 0, i).toLocaleTimeString([], { hour: 'numeric', hour12: true }) // Converts to '12 AM', '1 PM', etc.
	// }));

	minutes: any = Array.from({ length: 60 }, (_, i) => i.toString().padStart(2, '0'));


	editorConfig: AngularEditorConfig = {
		editable: true,
		spellcheck: true,
		height: '300',
		minHeight: '300',
		maxHeight: '300',
		width: 'auto',
		minWidth: '0',
		translate: 'yes',
		enableToolbar: true,
		showToolbar: true,
		defaultParagraphSeparator: '',
		defaultFontName: '',
		defaultFontSize: '',
		fonts: [
			{ class: 'arial', name: 'Arial' },
			{ class: 'times-new-roman', name: 'Times New Roman' },
			{ class: 'calibri', name: 'Calibri' },
			//{ class: 'comic-sans-ms', name: 'Comic Sans MS' }
		],
		customClasses: [{
			name: 'quote',
			class: 'quote',
		},
		{
			name: 'Title',
			class: 'titleText',
			tag: 'h2',
		},
		],
		sanitize: true,
		toolbarPosition: 'top',
		toolbarHiddenButtons: [
			[],
			['fontSize']
		]
	};

	descriptionHtmlContent: JSON;

	constructor(private _changeDetectorRef: ChangeDetectorRef, private fb: UntypedFormBuilder, private inventoryService: InventoryService, private educationService: EducationService, private globalSearchService: GlobalSearchService, private route: ActivatedRoute, public router: Router, private location: Location, private modalService: NgbModal, private printService: PrintService) {
		this.color = this.globalSearchService.getColor();
		
		this.inventoryService.getItemProductlines().subscribe((a) => {
			this.productlines = a;
		});
		this.inventoryService.getItemCategories().subscribe((a) => {
			this.categories = a;
		});
		this.inventoryService.getBrands().subscribe((a) => {
			this.brands = a;
		});
		this.educationService.getLocations().subscribe((a) => {
			this.eventlocations = a;
		});
		this.educationService.getRegions().subscribe((a) => {
			this.eventregions = a;
		});

	}
	
	ngOnInit(){
		this.setPagination([]);
		// initialize reactive filters
		this.searchCtrl.setValue(this.searchTerm, { emitEvent: false });
		this.statusCtrl.setValue(this.statusFilter, { emitEvent: false });
		this.searchCtrl.valueChanges
			.pipe(debounceTime(250), distinctUntilChanged())
			.subscribe((value: string) => {
				this.searching = true;
				this.searchTerm = value || '';
				this.filterEvents();
				this.searching = false;
			});
		this.statusCtrl.valueChanges
			.pipe(distinctUntilChanged())
			.subscribe((value: string) => {
				this.statusFilter = value || 'both';
				this.filterEvents();
			});
		this.getEvents();
	}
		// Method to get the appropriate Material icon for sorting
	getSortIcon(column: string): string {
		const sortVal = this.sortColumns.find(col => col.column === column);
	
		if(sortVal !== undefined) {
		
		return sortVal.sort === 'asc' ? 'arrow_upward' : 'arrow_downward';
		}
		return '';
	}
	
	onCheckboxChange(event: any, item: any) {
		
		const row = this.eventlist.find(col => col.events_id === item.events_id);
		console.log(row);
		if (event.target.checked) {
			this.sortedlist[this.sortedlist.indexOf(row)].checked = true;
			this.eventlist[this.eventlist.indexOf(row)].checked = true;
		} else {
			this.sortedlist[this.sortedlist.indexOf(row)].checked = false;
			this.eventlist[this.eventlist.indexOf(row)].checked = false;
		}

	}
	isChecked(item: any): boolean {
		let row = this.eventlist.find(col => col.events_id === item.events_id);
		return item.checked;
	}
	
	getEvents(){
		this.educationService.getEvents().subscribe((a) => {
			if (a) {
				this.eventlist = a;
				this.sortedlist = a;
				this.allevents = a;
				this.filterEvents();
			}
			this.eventForm = this.fb.group({
				name: ['', Validators.required],
				code: ['', Validators.required],
				alias: [''],
				web_link: [''],
				date_start: ['', Validators.required],
				date_end: ['', Validators.required],
				end_time: [''],
				start_time: [''],
				uses_total: ['0', Validators.required],
				uses_customer: ['0', Validators.required],
				discount: [0, Validators.required],
				logged: ['1'],
				region: [''],
				closed: ['0'],
				status: ['1'],
				image: [''],
				sell_sheet: [''],
				locations: [
					[]
				],
				artist_name: [''],
				host: [''],
				phone: [''],
				short_description: [''],
				description: [''],
			});
			this.desc2Ctrl.setValue('');
		});
	}

	deleteEvents(){
	
		let deleteList = [];
		this.eventlist.forEach((e) => {
	
		if(e.checked){
		deleteList.push(e.events_id);
		}
		});
		if(deleteList.length > 0){
		if (confirm('Are you sure you want to remove these events? This will remove all registration history associated with them')) {
		
			deleteList.forEach((a) => {
			
			this.deleteEvent(a);
			
			});
			
		}
		} else {
			alert('No Selection Made');
		}
	
	}
	setPagination(tableData) {
	
	let fields = [];
		this.sortColumns.forEach((col) => {
		if(col.sort == 'asc'){
			fields.push(col.column);
		} else {
			fields.push('-'+col.column);
		}
		});
		const fieldSorter = (fields) => (a, b) => fields.map(o => {
			let dir = 1;
			if (o[0] === '-') { dir = -1; o=o.substring(1); }
			if(!isNaN(parseFloat(a[o]))){
			return parseFloat(a[o]) > parseFloat(b[o]) ? dir : parseFloat(a[o]) < parseFloat(b[o]) ? -(dir) : 0;
			} else {
			return a[o] > b[o] ? dir : a[o] < b[o] ? -(dir) : 0;
			}
		}).reduce((p, n) => p ? p : n, 0);
		tableData.sort(fieldSorter(fields));
		
		this.dataSource = new MatTableDataSource < any > (tableData);
		this._changeDetectorRef.detectChanges();
		this.dataSource.paginator = this.paginator;
		this.dataObs = this.dataSource.connect();

	}
	sortTable(column: string) {
		this.sortedlist = this.eventlist;
		const sortVal = this.sortColumns.find(col => col.column === column);
		if (sortVal !== undefined) {
			if(sortVal.sort === 'asc'){
			this.sortColumns[this.sortColumns.indexOf(sortVal)].sort = 'desc';
			} else {
			this.sortColumns.splice(this.sortColumns.indexOf(sortVal),1);
			}
		} else {
			this.sortColumns.push({'column':column,sort: 'asc'});
		}
		/*
		let fields = [];
		this.sortColumns.forEach((col) => {
		if(col.sort == 'asc'){
			fields.push(col.column);
		} else {
			fields.push('-'+col.column);
		}
		});
		const fieldSorter = (fields) => (a, b) => fields.map(o => {
			let dir = 1;
			if (o[0] === '-') { dir = -1; o=o.substring(1); }
			if(!isNaN(parseFloat(a[o]))){
			return parseFloat(a[o]) > parseFloat(b[o]) ? dir : parseFloat(a[o]) < parseFloat(b[o]) ? -(dir) : 0;
			} else {
			return a[o] > b[o] ? dir : a[o] < b[o] ? -(dir) : 0;
			}
		}).reduce((p, n) => p ? p : n, 0);
		this.sortedlist.sort(fieldSorter(fields));
		*/
		this.setPagination(this.sortedlist);
		
	}
	exportPdf() {

		if (!this.printtablepdf) {
		  console.error('Print table element not found');
		  return;
		}
		
		const d = new Date();
		this.sending = true;
		const encoded = this.globalSearchService.base64encode(this.printtablepdf.nativeElement.innerHTML);
		
		const data = {
		  content: encoded,
		  filename: `${this.selected_event.name.replace(/[^a-zA-Z0-9]/g, '_')}_attendees`,
		  title: `${this.selected_event.name} Attendee Report ${d.toLocaleString()}`,
		  subtitle: 'Attendee List'
		};

	  
		this.printService.pdf(data).subscribe((result: any) => {
		  this.globalSearchService.downloadPdf(result.content, data.filename);
		  this.sending = false;
		});
	  }
	  
	  exportPdfMain() {

		if (!this.printtablepdfmain) {
		  console.error('Print table element not found');
		  return;
		}
		
		const d = new Date();
		this.sending = true;
		const encoded = this.globalSearchService.base64encode(this.printtablepdfmain.nativeElement.innerHTML);
		
		const data = {
		  content: encoded,
		  filename: `event_listing`,
		  title: `Event Listing -  ${d.toLocaleString()}`,
		};

	  
		this.printService.pdf(data).subscribe((result: any) => {
		  this.globalSearchService.downloadPdf(result.content, data.filename);
		  this.sending = false;
		});
	  }

	exportXlsMain() {

		if (!this.printtablepdfmain) {
			console.error('Print table element not found');
			return;
		}
		const d = new Date();
		this.sending = true;
		const encoded = this.globalSearchService.base64encode(this.printtablepdfmain.nativeElement.innerHTML);

		const data = {
			content: encoded,
			filename: `event_listing`,
			title: `Event Listing -  ${d.toLocaleString()}`
		};

		this.printService.xls(data).subscribe((result: any) => {
			this.globalSearchService.downloadXls(result.content, data.filename);
			this.sending = false;
		});
	}

	viewAttendees(eventid: any) {
		const data = { eventid: eventid };
		this.educationService.getAttendees(data).subscribe((a) => {
			this.selected_event = a;
			this.modalService.open(this.attendeeRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

			}, (reason) => {
				this.getEvents();
			});
		});
	}

	removeReg(regData: number) {
		const attendeeToRemove = this.selected_event.history[regData];

		if (confirm('Are you sure you want to remove this registration?')) {
			const data = {
				registrationId: attendeeToRemove.events_history_id,
				eventId: this.selected_event.history[regData]['events_id'],
				name: attendeeToRemove.registrant,
				order_id: attendeeToRemove.order_id
			};

			this.educationService.removeAtendee(data).subscribe({
				next: (response) => {
					this.selected_event = response;
					this.globalSearchService.showNotification(
						'Registration successfully removed',
						'success',
						'bottom',
						'right'
					);
				},
				error: (error) => {
					this.globalSearchService.showNotification(
						'Error removing registration',
						'danger',
						'bottom',
						'right'
					);
				}
			});
		}
	}

	addEvent() {
		this.productlist = [];
		this.selected_event = false;
		this.eventForm = this.fb.group({
			name: ['', Validators.required],
			code: ['', Validators.required],
			alias: [''],
			web_link: [''],
			date_start: ['', Validators.required],
			date_end: ['', Validators.required],
			start_time: ['', Validators.required],
			end_time: ['',Validators.required],
			uses_total: ['0', Validators.required],
			uses_customer: ['0', Validators.required],
			discount: [0, Validators.required],
			logged: ['1'],
			region: [''],
			closed: ['0'],
			status: ['1'],
			image: [''],
			sell_sheet: [''],
			locations: [
				[]
			],
			artist_name: [''],
			host: [''],
			phone: [''],
			short_description: [''],
			description: [''],
		});
		this.desc2Ctrl.setValue('');
		this.modalService.open(this.setupRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

		}, (reason) => {

		});
	}
	editEvent(eventid: any) {
		const data = { eventid: eventid };
		this.educationService.getEvent(data).subscribe((a) => {
			this.selected_event = a;
			this.eventForm = this.fb.group({
				name: [a.name, Validators.required],
				code: [a.code, Validators.required],
				alias: [a.alias],
				web_link: [a.web_link],
				date_start: [new Date(a.date_start), Validators.required],
				date_end: [new Date(a.date_end), Validators.required],
				end_time: [a.end_time],
				start_time: [a.start_time],
				uses_total: [a.uses_total, Validators.required],
				uses_customer: [a.uses_customer, Validators.required],
				discount: [a.discount, Validators.required],
				logged: [a.logged],
				region: [''],
				closed: [a.closed],
				status: [a.status],
				image: [a.image],
				sell_sheet:[a.sell_sheet],
				locations: [a.location.event_locations],
				artist_name: [a.artist_name],
				host: [a.host],
				phone: [a.phone],
				short_description: [a.short_description],
				description: [a.description],
			});
			this.desc2Ctrl.setValue(a.description);
			this.productlist = a.products;

			this.modalService.open(this.setupRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

			}, (reason) => {

			});
		});
	}
	saveEvent() {
		if (this.eventForm.valid) {
			this.saving = true;
			const data = { eventid: this.selected_event.events_id, eventdetails: this.eventForm.value, productlist: this.productlist };

			this.educationService.saveEvent(data).subscribe({
				next: (a) => {
					if (a.success) {
						this.eventlist = a.list;
						
						this.filteredData();
						this.setPagination(this.eventlist);
						this.selected_event = [];
						this.productlist = [];
						this.picklist = [];
						this.modalService.dismissAll();
						this.globalSearchService.showNotification(
							'Event saved successfully',
							'success',
							'bottom',
							'right'
						);
					} else {
						this.globalSearchService.showNotification(
							`Error saving event: ${a.error}`,
							'danger',
							'bottom',
							'right'
						);
					}
					this.saving = false;
				},
				error: (error) => {
					this.globalSearchService.showNotification(
						'Error saving event. Please try again.',
						'danger',
						'bottom',
						'right'
					);
					this.saving = false;
				}
			});
		} else {
			this.eventForm.markAllAsTouched();
			this.getFormValidationErrors(this.eventForm);
			this.globalSearchService.showNotification(
				'Please fix the form errors before saving',
				'warning',
				'bottom',
				'right'
			);
		}
	}

	deleteEvent(eventid: any) {
		const data = { eventid: eventid };
		this.educationService.deleteEvent(data).subscribe((a) => {
			this.eventlist = a;
			this.filteredData();
			this.setPagination([]);
			this.setPagination(this.eventlist);
		});
	}

	toggleVis(index: any) {
		this.selected_event.history[index].show = !this.selected_event.history[index].show;
	}

	getProducts() {
		const data = { cats: this.categoryCtrl.value, prods: this.prodCtrl.value, brands: this.brandCtrl.value, desc: this.descCtrl.value };
		this.productsSearching = true;
		this.educationService.getProducts(data).subscribe({
			next: (a) => {
				this.picklist = a;
				this.productsSearching = false;
			},
			error: () => {
				this.productsSearching = false;
			}
		});
	}

	addProducts() {
		this.picklist.forEach((i) => {
			const p = { stockid: i.stockid, description: i.description };
			this.productlist.push(p);
		});
		this.picklist = [];
	}

	addSingleProduct(product: any) {
		const p = { stockid: product.stockid, description: product.description };
		this.productlist.push(p);
		// Remove from picklist
		const index = this.picklist.indexOf(product);
		if (index >= 0) {
			this.picklist.splice(index, 1);
		}
	}

	excludeProduct(item: any) {
		const index = this.picklist.indexOf(item);
		if (index >= 0) {
			this.picklist.splice(index, 1);
		}
	}

	removeProduct(item: any) {
		const index = this.productlist.indexOf(item);
		if (index >= 0) {
			this.productlist.splice(index, 1);
		}
	}

	back(): void {
		this.location.back()
	}

	onUploadError(event: any) {

	}

	onUploadSuccess(event: any) {

	}

	getFormValidationErrors(form: any) {
		Object.keys(form.controls).forEach((key, index) => {
			const controlErrors: ValidationErrors = form.get(key).errors;

			if (controlErrors != null) {
				Object.keys(controlErrors).forEach(keyError => {
					//this.customerForm.controls[index].markAsTouched()
					form.markAllAsTouched();
					//form.markAsUntouched()

					this.globalSearchService.showNotification(key + ' ' + keyError, 'danger', 'bottom', 'right')
				});
			}
		});
	}

	// Function to filter data based on search term and status filter
	filteredData() {
		return this.eventlist.filter(item => {
			const matchesSearch = this.searchTerm === '' ||
				item.name.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
				item.host.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
				item.city.toLowerCase().includes(this.searchTerm.toLowerCase());

			
			const matchesStatus = this.statusFilter === 'both' ||
				(this.statusFilter.toLocaleLowerCase() === 'enabled' && item.status_bool == '1') ||
				(this.statusFilter.toLocaleLowerCase() === 'disabled' && item.status_bool != '1');
			
			return matchesSearch && matchesStatus;
		});
	}
	
	filterEvents() {

		if(this.searchTerm === ''){
			if(this.statusFilter.toLocaleLowerCase() === 'both'){
				this.eventlist = this.allevents;
				this.setPagination(this.eventlist);
			} else if (this.statusFilter.toLocaleLowerCase() === 'enabled'){
				this.eventlist = this.globalSearchService.filterItem(this.allevents, '1', 'status_bool');
				this.setPagination(this.eventlist);
			} else if (this.statusFilter.toLocaleLowerCase() === 'disabled'){
				this.eventlist = this.globalSearchService.filterItem(this.allevents, '0', 'status_bool');
				this.setPagination(this.eventlist);
			}
		} else {
			if(this.statusFilter.toLocaleLowerCase() === 'both'){
				this.eventlist = this.globalSearchService.filterItem(this.allevents, this.searchTerm, 'name,host,city');
				this.setPagination(this.eventlist);
			} else if (this.statusFilter.toLocaleLowerCase() === 'enabled'){
				this.eventlist = this.globalSearchService.filterItem(this.allevents, '1', 'status_bool');
				this.eventlist = this.globalSearchService.filterItem(this.eventlist, this.searchTerm, 'name,host,city');
				this.setPagination(this.eventlist);
			} else if (this.statusFilter.toLocaleLowerCase() === 'disabled'){
				this.eventlist = this.globalSearchService.filterItem(this.allevents, '0', 'status_bool');
				this.eventlist = this.globalSearchService.filterItem(this.eventlist, this.searchTerm, 'name,host,city');
				this.setPagination(this.eventlist);
			}		
		}

	}
	
	onSelect(cat: any, event: any) {
		this.files.push(...event.addedFiles);
		for (let i = 0; i < this.files.length; i++) {
			this.readFile(this.files[i]).then(fileContents => {
				//stuff

				const upload = {
					content: fileContents,
					name: event.addedFiles[0].name,
					mime: event.addedFiles[0].type,
				}

				this.educationService.uploadEduFile(upload, cat).subscribe((results: any) => {
					this.selected_event.thumb = results.thumb;
					this.eventForm.get('image').setValue(results.file);
				});

			});
		}
	}
	onSelect2(cat: any, event: any) {
		this.files.push(...event.addedFiles);
		for (let i = 0; i < this.files.length; i++) {
			this.readFile(this.files[i]).then(fileContents => {
				//stuff

				const upload = {
					content: fileContents,
					name: event.addedFiles[0].name,
					mime: event.addedFiles[0].type,
				}

				this.educationService.uploadEduFile(upload, cat).subscribe((results: any) => {
					this.selected_event.sell_sheet = results.file;
					this.eventForm.get('sell_sheet').setValue(results.file);
				});

			});
		}
	}
	updateForm(control, event) {
		this.eventForm.get('description').setValue(event);
	}
	private async readFile(file: File): Promise < string | ArrayBuffer > {
		return new Promise < string | ArrayBuffer > ((resolve, reject) => {
			const reader = new FileReader();

			reader.onload = e => {
				return resolve((e.target as FileReader).result);
			};

			reader.onerror = e => {
				console.error(`FileReader failed on file ${file.name}.`);
				return reject(null);
			};

			if (!file) {
				return reject(null);
			}
			reader.readAsDataURL(file);
		});

		this.files = [];
	}

}